/**
 * Копирование текста в буфер обмена (Clipboard API). В небезопасном контексте (http не на
 * localhost) API нет — ошибка, вызывающий показывает тост «Не удалось скопировать».
 */
export async function copyText(text: string): Promise<void> {
  if (typeof navigator === 'undefined' || !('clipboard' in navigator)) {
    throw new Error('clipboard: API unavailable');
  }
  await navigator.clipboard.writeText(text);
}
